export const createAction = (type, payload) => {
  if (!type) {
    throw new Error('An action must have a type')
  }

  return { type, payload }
}

export default createAction
